<template>
  <path fill-rule="evenodd" d="M89.396 1.416C78.97 1.23 30.054-3.989 14.664 9.552-.679 23.052-4.515 50.424 9.367 60.868c13.88 10.444 59.595 7.865 71.867 8.086 8.014.144 51.717-1.512 67.337-11.41 10.97-6.95 14.2-21.071 5.517-36.438-8.782-18.895-57.636-19.562-64.692-19.69z"/>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// components/_SVG/ShapeYearBtn1Tab.vue